/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/BusinessEmbedSummarySpaAppsQuery$parameters.ts';
import type { BusinessEmbedSummarySpaAppsQuery } from './__generated__/BusinessEmbedSummarySpaAppsQuery.graphql.ts';

type SummaryBusinessEmbedEntrypointComponent = EntryPointComponent<
	{
		summaryQuery: BusinessEmbedSummarySpaAppsQuery;
	},
	{},
	{},
	{}
>;

export const summaryBusinessEmbedEntrypoint: EntryPoint<
	SummaryBusinessEmbedEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SummaryBusinessEmbedEntrypointComponent>(
		/* webpackChunkName: "async-summary-business-embed-entrypoint" */ './BusinessEmbedSummarySpaApps.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				summaryQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
			},
		};
	},
});
